export default function (app) {
  const { steps } = app;
  return steps.length === 1 && steps[0].tabs.length === 1 && steps[0].tabs[0].key !== 'other';
}
